<div class="container-fluid p-0">
  <div class="hpanel">
    <div class="panel-body b-r-6">
      <div class="card">
        <div class="card-header p-10-30">
          <h6>Manage members for your organization</h6>
        </div>
        <div class="card-body">
          <ng-container *ngIf="isBusinessOrEnterpriseUser; else showUpgradeMessage">
          <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
          <div class="row">
            <div class="col-sm-12">
              <app-customer-search [placeholder]="'Search by user, email or company'"></app-customer-search>
            </div>
            <div class="custom-datatable col-lg-12 col-md-12 col-sm-12">
              <!-- Empty state -->
              <div *ngIf="listToShow?.length === 0" class="datatable-empty-state">
                <app-nodata-found
                  [title]="['No members found']"
                  [screen]="'EMPTY'"
                  [buttonShow]="false">
                </app-nodata-found>
              </div>

              <!-- Datatable with data -->
              <div *ngIf="listToShow?.length > 0">
                <ngx-datatable  #sortTable  (sort)="onSort($event)" class="bootstrap" [rows]="listToShow" [columnMode]="'force'" [headerHeight]="40"
                  [footerHeight]="50" rowHeight="auto" [selectAllRowsOnPage]="false" [externalPaging]="true"
                  [count]="userPayload.total" [scrollbarH]="true" [offset]="userPayload.page" [limit]="10"
                  (select)='onSelect($event)' (page)="nextPage($event)">
                  <ngx-datatable-column cellClass="custom-cell" name="User">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{util.mergeNames(row.firstName, row.lastName)}}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [width]="200" name="Email ID" prop="email">
                  </ngx-datatable-column>
                  <ngx-datatable-column [canAutoResize]="true" [resizeable]="true" name="Role" prop="userType">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <div class="custom-cell">{{ row.userType | MTAPipe: 'convertMTA' | titlecase }}</div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Company" prop="organisation">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <ng-container>
                        {{row.organisation || "N/A"}}
                      </ng-container>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Company Type" prop="clientType">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <ng-container>
                        {{row.clientType || "N/A"}}
                      </ng-container>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Contact Type" prop="contactType">
                  </ngx-datatable-column>
                  <ngx-datatable-column [width]="200" cellClass="colValuesync" name="Network" prop="networkName">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="network-container" [attr.title]="getTooltipText(row.networkName)">
                        <span style="max-width:131px;">{{ getNetworkDisplayName(row.networkName).name }}</span>
                        <span *ngIf="getNetworkDisplayName(row.networkName).count > 0" class="network-count-box">
                          +{{ getNetworkDisplayName(row.networkName).count }}
                        </span>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column cellClass="colValuesync" name="Partner since" prop="startDate">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <ng-container>
                        {{ row.startDate ? (row.startDate | timezoneDate:'MM/dd/yyyy') : 'N/A' }}
                      </ng-container>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column cellClass="colValuesync" name="Last Active">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <label>
                        {{row.lastLoggedOn | timezoneDate:'MM/dd/yyyy'}}
                      </label>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column cellClass="colValuesync" name="Status" prop="connectionStatus">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <label
                        [ngClass]="{'connected': row.connectionStatus === 'CONNECTED','inactive-status-table': row.connectionStatus === 'INACTIVE', 'request-sent': row.connectionStatus === 'REQUEST_SENT'}"
                        class="capitalize-first"> {{ value === 'REQUEST_SENT'? 'Requested':value | underscoreRemovePipe
                        }}</label>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column  [width]="150" cellClass="colValuesync" name="Actions" prop="name">
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <div class="wrapper">
                        <span class="action-items">
                          <ng-icon name="tablerEye" class="svg-position" (click)="openViewmodal(row)"></ng-icon>
                        </span>
                        <span class="action-items">
                          <ng-icon name="tablerPencil" class="svg-position" (click)="openEditModal(row)"></ng-icon>
                        </span>
                        <span class="action-items" [matMenuTriggerFor]="menu" aria-label="More options">
                          <ng-icon name="tablerDots" class="svg-position"></ng-icon>
                        </span>
                        <div class="customer-contact-menu">
                          <mat-menu #menu="matMenu">
                            <button *ngIf="['CONNECTED', 'INACTIVE'].includes(row.connectionStatus)" mat-menu-item
                              (click)="removeUserContact(row)">
                              Remove Contact
                            </button>
                            <button *ngIf="row.connectionStatus === 'REQUEST_SENT'" mat-menu-item
                              (click)="handleInvite(row, 'CANCEL')">
                              Cancel Request
                            </button>
                          </mat-menu>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #showUpgradeMessage>
          <app-upgrade-message
            [allocationCards]="allocationCards">
          </app-upgrade-message>
        </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>


<app-common-modal *ngIf="showModal" [title]="'contacts'" [type]="'EDIT'" [data]="contactData"
  (response)="closeModal($event)">
</app-common-modal>
